import submit from "submit-form";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import { getPushTestEmail } from "../../../../utils/user-helpers";
import { useRillContext } from "../../../../rill/RillReact/share/base";

const sendInvite = (
  e,
  email,
  feId,
  name,
  plan,
  googlePlayLink,
  appStoreLink
) => {
  e.preventDefault();
  submit(`/actions/stores/push-invite`, {
    method: "POST",
    body: {
      email,
      feId,
      name,
      plan,
      googlePlayLink,
      appStoreLink,
    },
  });
};

const TestPushAccountModal = (props) => {
  const { locals } = useRillContext();
  const { t } = useTranslation("coaching-portal");

  const testEmail = getPushTestEmail(locals.activeUserToRequest.email);
  const feId = locals.activeUserToRequest._id;
  const name = locals.activeUserToRequest.name;
  const plan =
    locals.stripe && locals.stripe.plan ? locals.stripe.plan : "free_trial";
  const googlePlayLink =
    locals.activeUserToRequest.appStoreListingEnable &&
    locals.activeUserToRequest.googlePlayLink
      ? locals.activeUserToRequest.googlePlayLink
      : "https://play.google.com/store/apps/details?id=com.mystrengthbook&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";
  const appStoreLink =
    locals.activeUserToRequest.appStoreListingEnable &&
    locals.activeUserToRequest.appStoreLink
      ? locals.activeUserToRequest.appStoreLink
      : "https://apps.apple.com/us/app/mystrengthbook/id1337179045";

  return (
    <Modal
      canClose={false}
      title={t("store.testPushAccountModal.title")}
      narrow
      className="test-account-modal"
    >
      <div className="body">
        <h4 className="mt-0 mb-6">
          {t("store.testPushAccountModal.checkEmail")}
        </h4>
        <p className="p2 mb-4">
          {t("store.testPushAccountModal.body")}{" "}
          <span className="text-(--information)">
            {locals.activeUser.email}
          </span>
          .
        </p>
        <span className="chip info mb-2 h-8 py-0 ">
          {t("store.testPushAccountModal.testAccountEmail")} {testEmail}
        </span>
        <span className="chip warning h-8 py-0">
          {t("store.testPushAccountModal.notCharged")}
        </span>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="primary"
          onClick={(e) =>
            sendInvite(
              e,
              testEmail,
              feId,
              name,
              plan,
              googlePlayLink,
              appStoreLink
            )
          }
        >
          {t("store.testPushAccountModal.sendInvite")}
        </a>
      </footer>
    </Modal>
  );
};

export default TestPushAccountModal;
